
import { CircularProgress, Modal } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Button from '../../../components/common/Button';
import ModalContent from '../../../components/common/Modal/ModalContent';
import workshopApi from '../../WorkShopContainer/workshop-api';
import Alert from '../../../components/common/Alert';

const WorkshopsModal = ({ open, onClose, announcement, handleOpen }) => {
  // Buscador para talleres seleccionados en el primer modal
  const [selectedSearch, setSelectedSearch] = useState('');
  // Toggle seleccionar todos en la columna izquierda (disponibles)
  const [loading, setLoading] = useState(true);
  const [workshops, setWorkshops] = useState([]);
  const [selectedWorkshopIds, setSelectedWorkshopIds] = useState([]);
  const [message, setMessage] = useState(null);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [editorWorkshops, setEditorWorkshops] = useState([]);
  const [leftSearch, setLeftSearch] = useState('');
  const [rightSearch, setRightSearch] = useState('');

  useEffect(() => {
    if (open && announcement) {
      (async () => {
        try {
          const { data: allWorkshops } = await workshopApi.fetchWorkshops();
          const { data: announcementWorkshops } = await workshopApi.fetchWorkshopsByAnnouncement(announcement);
          const checkedWorkshops = allWorkshops.map((w) => {
            return announcementWorkshops.find((aw) => w.id === aw.workshopId.id)
              ? { ...w, checked: true }
              : { ...w, checked: false };
          });
          checkedWorkshops.sort((a, b) => a.title.localeCompare(b.title));
          setWorkshops(checkedWorkshops);
        } catch (error) {
          setMessage({ type: 'error', message: 'Error al cargar los talleres.' });
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [open, announcement]);

  // Abrir editor y preparar datos
  const openEditor = () => {
    setEditorWorkshops(
      workshops.map((w) => ({
        id: w.id,
        title: w.title,
        selected: w.checked,
        tempChecked: false // por defecto des-seleccionados en ambas columnas
      }))
    );
    setLeftSearch('');
    setRightSearch('');
    setIsEditorOpen(true);
  };

  // Toggle seleccionar todos en la columna izquierda (disponibles)
  const handleSelectAllLeft = () => {
    const disponibles = editorWorkshops.filter(w => !w.selected);
    const todosSeleccionados = disponibles.every(w => w.tempChecked);
    setEditorWorkshops(editorWorkshops.map(w =>
      !w.selected ? { ...w, tempChecked: !todosSeleccionados } : w
    ));
  };

  // Toggle seleccionar todos en la columna derecha (seleccionados)
  const handleSelectAllRight = () => {
    const seleccionados = editorWorkshops.filter(w => w.selected);
    const todosDesSeleccionados = seleccionados.every(w => !w.tempChecked);
    setEditorWorkshops(editorWorkshops.map(w =>
      w.selected ? { ...w, tempChecked: todosDesSeleccionados } : w
    ));
  };

  // Guardar cambios desde el editor
  const handleEditorSave = async (selectedWorkshops) => {
    const selectedIds = selectedWorkshops.map((w) => w.id);
    try {
      await workshopApi.associateWorkshopsWithAnnouncement(announcement, selectedIds);
      setMessage('Talleres guardados exitosamente.');
      // Actualizar talleres en el modal principal
      setWorkshops((prevWorkshops) =>
        prevWorkshops.map((w) => ({ ...w, checked: selectedIds.includes(w.id) }))
      );
      setSelectedWorkshopIds(selectedIds);
    } catch (error) {
      setMessage('Hubo un error al guardar los talleres.');
    }
    setIsEditorOpen(false);
    setSelectedSearch(''); // Limpiar filtro al guardar
  };

  // Cancelar edición
  const handleEditorCancel = () => {
    setIsEditorOpen(false);
    setSelectedSearch(''); // Limpiar filtro al cancelar
  };

  // Limpiar filtro y mensaje al cerrar el modal principal
  useEffect(() => {
    if (!open) {
      setSelectedSearch('');
      setMessage(null);
    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={onClose} className="modal">
        <ModalContent title="Gestión de talleres" onClick={onClose}>
          {message && (
            <div className="message-container">
              <Alert type={message.includes('error') ? 'error' : 'success'}>
                {message}
              </Alert>
            </div>
          )}
          <div className="box">
            <div className="box__header">
              <div
                style={{
                  background: '#f2f7fe',
                  color: '#1565c0',
                  borderRadius: '8px',
                  padding: '12px 12px',
                  fontSize: '16px',
                  display: 'inline-block',
                }}
              >
                <b style={{ fontWeight: 700, fontSize: '18px' }}>
                  {workshops.filter((w) => w.checked).length}
                </b>{' '}
                talleres seleccionados de {workshops.length} disponibles
              </div>
            </div>
            <hr />
            {/* Lista de talleres seleccionados con buscador */}
            {workshops.filter((w) => w.checked).length > 0 && (
              <div>
                <span
                  style={{
                    fontWeight: 500,
                    marginBottom: '6px',
                    display: 'block',
                  }}
                >
                  Talleres seleccionados:
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  <input
                    type="text"
                    placeholder="Buscar taller..."
                    style={{ flex: 1, padding: '6px 10px', borderRadius: 6, border: '1px solid #e0e0e0', fontSize: 14, background: '#fff', marginBottom: 0 }}
                    value={selectedSearch}
                    onChange={e => setSelectedSearch(e.target.value)}
                  />
                </div>
                <div
                  style={{
                    background: '#fff',
                    border: '1px solid #e0e0e0',
                    borderRadius: '6px',
                    padding: '10px 16px',
                    maxHeight: '180px',
                    overflowY: 'auto',
                  }}
                >
                  {workshops
                    .filter((w) => w.checked && (!selectedSearch || w.title.toLowerCase().includes(selectedSearch.toLowerCase())))
                    .map((workshop) => (
                      <div
                        key={workshop.id}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          color: '#388e3c',
                          marginBottom: '4px',
                          fontSize: '15px',
                        }}
                      >
                        {/* Ícono tipo ticket/check */}
                        <svg
                          style={{ marginRight: '8px' }}
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
                            fill="#388e3c"
                          />
                        </svg>
                        {workshop.title}
                      </div>
                    ))}
                  {workshops.filter((w) => w.checked && (!selectedSearch || w.title.toLowerCase().includes(selectedSearch.toLowerCase()))).length === 0 && (
                    <div style={{ textAlign: 'center', color: '#888', padding: '32px 0' }}>
                      {selectedSearch ? 'No se encontraron talleres' : 'No hay talleres seleccionados'}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <div className="modal__action-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button onClick={openEditor}>
              Editar Talleres
            </Button>
          </div>
        </ModalContent>
      </Modal>

      {/* Modal Editor de Talleres tipo transfer */}
      {isEditorOpen && (
        <Modal open={isEditorOpen} onClose={handleEditorCancel} className="modal">
          <div style={{ width: '900px', maxWidth: '95vw', maxHeight: '90vh', margin: '40px auto', background: '#fff', borderRadius: '12px', boxShadow: '0 2px 16px rgba(0,0,0,0.12)', padding: '32px', overflow: 'hidden' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: 16 }}>Editar talleres</h2>
            <div style={{ color: '#6b7280', fontSize: '15px', marginBottom: 18 }}>
              Selecciona los talleres correspondientes a la convocatoria
            </div>
            <div style={{ display: 'flex', gap: 24, height: 380 }}>
              {/* Columna izquierda - Talleres NO seleccionados */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', borderRadius: 8, background: '#fff' }}>
                <div style={{ padding: '16px 16px 8px 16px', borderBottom: '1px solid #e0e0e0', background: '#f7f8fa', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontWeight: 600, fontSize: 15 }}>Talleres disponibles para seleccionar</span>
                    <span style={{ fontWeight: 600, fontSize: 15, color: '#1565c0', background: '#e3f2fd', borderRadius: 6, padding: '2px 10px' }}>{editorWorkshops.filter(w => !w.selected).length}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <button style={{ fontSize: 13, padding: '4px 10px', border: '1px solid #bdbdbd', borderRadius: 6, background: '#fff', cursor: 'pointer' }}
                      onClick={handleSelectAllLeft}
                      disabled={editorWorkshops.filter(w => !w.selected).length === 0}
                    >Seleccionar todos</button>
                    <input
                      type="text"
                      placeholder="Buscar talleres..."
                      style={{ flex: 1, padding: '6px 10px', borderRadius: 6, border: '1px solid #e0e0e0', fontSize: 14, background: '#fff', marginBottom: 0 }}
                      value={leftSearch}
                      onChange={e => setLeftSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ flex: 1, overflowY: 'auto', padding: 12 }}>
                  {editorWorkshops.filter(w => !w.selected && (!leftSearch || w.title.toLowerCase().includes(leftSearch.toLowerCase()))).map(workshop => (
                    <div key={workshop.id} style={{ display: 'flex', alignItems: 'center', padding: '6px 0' }}>
                      <input type="checkbox" checked={!!workshop.tempChecked} onChange={e => setEditorWorkshops(editorWorkshops.map(w => w.id === workshop.id ? { ...w, tempChecked: e.target.checked } : w))} />
                      <span style={{ marginLeft: 8, fontSize: 14 }}>{workshop.title}</span>
                    </div>
                  ))}
                  {editorWorkshops.filter(w => !w.selected && (!leftSearch || w.title.toLowerCase().includes(leftSearch.toLowerCase()))).length === 0 && (
                    <div style={{ textAlign: 'center', color: '#888', padding: '32px 0' }}>
                      {leftSearch ? 'No se encontraron talleres' : 'Todos los talleres están seleccionados'}
                    </div>
                  )}
                </div>
              </div>
              {/* Botones de transferencia */}
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 12 }}>
                <button style={{ padding: 8, borderRadius: 6, border: '1px solid #bdbdbd', background: '#fff', cursor: 'pointer' }}
                  onClick={() => setEditorWorkshops(editorWorkshops.map(w => {
                    if (w.tempChecked && !w.selected) {
                      // Mover de izquierda a derecha y des-seleccionar
                      return { ...w, selected: true, tempChecked: false };
                    }
                    return w;
                  }))}
                  disabled={editorWorkshops.filter(w => w.tempChecked && !w.selected).length === 0}
                >→</button>
                <button style={{ padding: 8, borderRadius: 6, border: '1px solid #bdbdbd', background: '#fff', cursor: 'pointer' }}
                  onClick={() => setEditorWorkshops(editorWorkshops.map(w => {
                    if (w.tempChecked && w.selected) {
                      // Mover de derecha a izquierda y des-seleccionar
                      return { ...w, selected: false, tempChecked: false };
                    }
                    return w;
                  }))}
                  disabled={editorWorkshops.filter(w => w.tempChecked && w.selected).length === 0}
                >←</button>
              </div>
              {/* Columna derecha - Talleres seleccionados */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', borderRadius: 8, background: '#fff' }}>
                <div style={{ padding: '16px 16px 8px 16px', borderBottom: '1px solid #e0e0e0', background: '#f7f8fa', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontWeight: 600, fontSize: 15 }}>Talleres seleccionados</span>
                    <span style={{ fontWeight: 600, fontSize: 15, color: '#388e3c', background: '#e8f5e9', borderRadius: 6, padding: '2px 10px' }}>{editorWorkshops.filter(w => w.selected).length}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <button style={{ fontSize: 13, padding: '4px 10px', border: '1px solid #bdbdbd', borderRadius: 6, background: '#fff', cursor: 'pointer' }}
                      onClick={handleSelectAllRight}
                      disabled={editorWorkshops.filter(w => w.selected).length === 0}
                    >Seleccionar todos</button>
                    <input
                      type="text"
                      placeholder="Buscar talleres..."
                      style={{ flex: 1, padding: '6px 10px', borderRadius: 6, border: '1px solid #e0e0e0', fontSize: 14, background: '#fff', marginBottom: 0 }}
                      value={rightSearch}
                      onChange={e => setRightSearch(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ flex: 1, overflowY: 'auto', padding: 12 }}>
                  {editorWorkshops.filter(w => w.selected && (!rightSearch || w.title.toLowerCase().includes(rightSearch.toLowerCase()))).map(workshop => (
                    <div key={workshop.id} style={{ display: 'flex', alignItems: 'center', padding: '6px 0' }}>
                      <input type="checkbox" checked={!!workshop.tempChecked} onChange={e => setEditorWorkshops(editorWorkshops.map(w => w.id === workshop.id ? { ...w, tempChecked: e.target.checked } : w))} />
                      <span style={{ marginLeft: 8, fontSize: 14 }}>{workshop.title}</span>
                    </div>
                  ))}
                  {editorWorkshops.filter(w => w.selected && (!rightSearch || w.title.toLowerCase().includes(rightSearch.toLowerCase()))).length === 0 && (
                    <div style={{ textAlign: 'center', color: '#888', padding: '32px 0' }}>
                      {rightSearch ? 'No se encontraron talleres' : 'No hay talleres seleccionados'}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, paddingTop: 24, borderTop: '1px solid #e0e0e0', marginTop: 24 }}>
              <Button secondary onClick={handleEditorCancel}>
                Volver
              </Button>
              <Button onClick={() => handleEditorSave(editorWorkshops.filter(w => w.selected))}>
                Guardar
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default WorkshopsModal;
